// User-facing error text (CODE_REVIEW S19). Internal error messages are English and technical; the UI
// shows a translated, plain sentence picked from the error's name or message, and the raw message goes
// to the console (and to a tooltip in the Pro failure list) for anyone who needs the detail.
import type { MessageKey } from './index';

const RULES: [RegExp, MessageKey][] = [
  [/^DecodeError:unsupported/, 'errUnsupported'],
  [/^DecodeError:corrupt/, 'errCorrupt'],
  [/^DecodeError:heic-unavailable/, 'errHeic'],
  [/ZipTooLarge|larger than 3\.5 GB/, 'errZipTooLarge'],
  [/graphics card was reset|context lost/i, 'errGpuReset'],
  [/could not start/, 'errWorker'],
  [/not a Lightroom/, 'errNotXmp'],
  [/^refused:|WriteGuard/, 'errRefused'],
];

/** The message key for an error (or an error's text as stored in a failure list). */
export function errorKey(e: unknown): MessageKey {
  const name = e instanceof Error ? e.name : '';
  const msg = e instanceof Error ? e.message : String(e);
  for (const [re, key] of RULES) if (re.test(name) || re.test(msg)) return key;
  return 'errGeneric';
}
